import { ProductDocument } from 'models/product';
import { Controller } from 'react-hook-form';
import { useUpdateBid } from '../hooks/useUpdateBid';
import FormCurrencyInputFancy from '@c/forms/controls/FormCurrencyInputFancy';
import Button from '@ui/Button';

export function UpdateBidForm({
  product,
  onSubmitSuccess,
  updateBidPrice,
}: {
  product: ProductDocument;
  onSubmitSuccess: () => void;
  updateBidPrice: number;
}) {
  const {
    useFormReturn: {
      control,
      formState: { errors, isSubmitting },
      clearErrors,
      handleSubmit,
    },
    onSubmit,
  } = useUpdateBid({
    product,
    updateBidPrice,
    onSubmitSuccess,
  });
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 p-4">
      <div className="mt-8">
        <div className="flex w-full items-center justify-between rounded-[1.5rem] border border-[#D9D9D9] p-4 px-8">
          <span className="text-[2rem] font-medium text-black">Your Bid</span>
          <Controller
            control={control}
            name={`price`}
            render={({ field: { value, onChange, onBlur } }) => (
              <FormCurrencyInputFancy
                placeholder={'0.00'}
                error={!!errors.price}
                onChange={(e) => {
                  clearErrors('price');
                  onChange(e);
                }}
                value={value > 0 ? value.toFixed(2) : ''}
                onBlur={onBlur}
                className={`!text-[1.8rem] ${
                  errors.price ? 'text-brand-secondary' : '!text-black'
                }`}
              />
            )}
          />
        </div>
        {errors.price && (
          <span className="text-[1.5rem] font-semibold text-brand-red ">
            {errors.price.message}
          </span>
        )}
      </div>
      <div className="mt-8">
        <div className="flex w-full items-center justify-between rounded-[1.5rem] border border-[#D9D9D9] p-4 px-8">
          <span className="text-[2rem] font-medium text-black">Max Bid</span>
          <Controller
            control={control}
            name={`maxPrice`}
            render={({ field: { value, onChange, onBlur } }) => (
              <FormCurrencyInputFancy
                placeholder={'0.00'}
                error={!!errors.maxPrice}
                onChange={(e) => {
                  clearErrors('maxPrice');
                  onChange(e);
                }}
                value={value && value > 0 ? value.toFixed(2) : ''}
                onBlur={onBlur}
                className={`!text-[1.8rem] ${
                  errors.price ? 'text-brand-secondary' : '!text-black'
                }`}
              />
            )}
          />
        </div>
        <div className="mt-4 text-[1.5rem] font-medium text-brand-dark-gray">
          We will automatically rebid up to your max bid plus $1 if you are out
          bid.
        </div>
        {errors.maxPrice && (
          <span className="text-[1.5rem] font-semibold text-brand-red ">
            {errors.maxPrice.message}
          </span>
        )}
      </div>
      <Button
        className="w-full"
        text="Update Bid"
        type="secondary"
        buttonType="submit"
        loading={isSubmitting}
      />
    </form>
  );
}
